import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const { signup, confirmSignUp } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }

    try {
      setError('');
      setLoading(true);
      const { isSignUpComplete, nextStep } = await signup(email, password);
      console.log('Signup response:', { isSignUpComplete, nextStep });
      
      if (nextStep.signUpStep === 'CONFIRM_SIGN_UP') {
        setShowVerification(true);
      } else if (isSignUpComplete) {
        navigate('/kb');
      }
    } catch (error) {
      console.error('Signup error:', error);
      setError(error.message || 'Failed to create an account');
    } finally {
      setLoading(false);
    }
  }

  async function handleVerification(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await confirmSignUp(email, verificationCode);
      navigate('/kb');
    } catch (error) {
      console.error('Verification error:', error);
      setError(error.message || 'Failed to verify code');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <h2>Sign Up</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      
      {!showVerification ? (
        <form onSubmit={handleSubmit}>
          <div>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button disabled={loading} type="submit">
            Sign Up
          </button>
        </form>
      ) : (
        <form onSubmit={handleVerification}>
          <div>
            <label>Verification Code</label>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              required
            />
          </div>
          <button disabled={loading} type="submit">
            Verify Email
          </button>
        </form>
      )}
      
      <div>
        Already have an account? <Link to="/login">Log In</Link>
      </div>
    </div>
  );
}
